import styled from 'styled-components';

import { Skeleton } from '@sorare/core/src/atoms/animations/Skeleton';
import { mobileAndAbove } from '@sorare/core/src/style/mediaQuery';

export const PlayerBlockSkeleton = styled(Skeleton)`
  border-radius: var(--unit);
  height: 66px;
  width: 290px;
  @media ${mobileAndAbove} {
    width: 320px;
  }
`;
